<template>
  <iframe
    :id="content.fichierHtml['@path']"
    class="w-100 vh-100"
    :title="content.fichierHtml['@name']"
    :src="jel_getFichierSrc(content.fichierHtml)"
    frameborder="0"
    scrolling="no"
  />
</template>

<script>
export default {
  name: 'IframeHTML',
  props: { content: { type: Object, required: true } },
  mounted() {
    // nécessaire pour éviter d'avoir deux scroll verticaux dans la page
    const iframe = document.getElementById(this.content.fichierHtml['@path']);
    iframe.onload = function () {
      iframe.height = iframe.contentWindow.document.body.scrollHeight;
      // important à conserver pour avoir un effet plus fluide lors du chargement
      iframe.classList.remove('vh-100');
    };
  },
};
</script>
